import { getIsoDate } from '../../utils/dateUtils';
import type { ApiClient } from '../clients/ApiClient';
import type { ISODate, ISODateTime } from '../models/bff';

/**
 * Abstract base repository class.
 * All domain repositories should extend this class.
 *
 * @template TEndpoint - Union type of allowed endpoint strings for the API client
 */
export abstract class BaseRepository<TEndpoint extends string = string> {
  /** Name used as the access property to this repository.
   * Example: `name = 'myRepo'` will be turned into `$api.myRepo`
   */
  static name: string;
  protected apiClient: ApiClient<TEndpoint>;

  constructor(apiClient: ApiClient<TEndpoint>) {
    this.apiClient = apiClient;
  }

  /**
   * Format a date for the API (YYYY-MM-DD)
   * @param date - Date to format
   * @returns Formatted date string (YYYY-MM-DD)
   */
  formatDateForApi(date: Parameters<typeof getIsoDate>[0]): ISODate {
    return getIsoDate(date);
  }

  /**
   * Format a date for the API (YYYY-MM-DDTHH:MM:SSZ)
   * @param date - DateTime to format
   * @returns Formatted date string (YYYY-MM-DDTHH:MM:SSZ)
   */
  formatDateTimeForApi(date: Parameters<typeof getIsoDate>[0]): ISODateTime {
    return new Date(date).toISOString();
  }
}
